export const ordersTypes = {
  GET_ORDERS_REQUEST: "GET_ORDERS_REQUEST",
  GET_ORDERS_SUCCESS: "GET_ORDERS_SUCCESS",
  GET_ORDERS_FAILURE: "GET_ORDERS_FAILURE",

  GET_ORDER_REQUEST: "GET_ORDER_REQUEST",
  GET_ORDER_SUCCESS: "GET_ORDER_SUCCESS",
  GET_ORDER_FAILURE: "GET_ORDER_FAILURE",

  GET_ORDER_CLEAR_ERROR: "GET_ORDER_CLEAR_ERROR",

  GET_ORDER_FILE_REQUEST: "GET_ORDER_FILE_REQUEST",
  GET_ORDER_FILE_SUCCESS: "GET_ORDER_FILE_SUCCESS",
  GET_ORDER_FILE_FAILURE: "GET_ORDER_FILE_FAILURE",

  POST_ORDER_SPECIMEN_REQUEST: "POST_ORDER_SPECIMEN_REQUEST",
  POST_ORDER_SPECIMEN_SUCCESS: "POST_ORDER_SPECIMEN_SUCCESS",
  POST_ORDER_SPECIMEN_FAILURE: "POST_ORDER_SPECIMEN_FAILURE",

  POST_ORDER_SPECIMEN_WITHOUT_REFRESH_REQUEST: "POST_ORDER_SPECIMEN_WITHOUT_REFRESH_REQUEST",
  POST_ORDER_SPECIMEN_WITHOUT_REFRESH_SUCCESS: "POST_ORDER_SPECIMEN_WITHOUT_REFRESH_SUCCESS",
  POST_ORDER_SPECIMEN_WITHOUT_REFRESH_FAILURE: "POST_ORDER_SPECIMEN_WITHOUT_REFRESH_FAILURE",

  PUT_PRODUCT_REQUEST: "PUT_PRODUCT_REQUEST",
  PUT_PRODUCT_SUCCESS: "PUT_PRODUCT_SUCCESS",
  PUT_PRODUCT_FAILURE: "PUT_PRODUCT_FAILURE",

  PUT_PRODUCT_WITHOUT_REFRESH_REQUEST: "PUT_PRODUCT_WITHOUT_REFRESH_REQUEST",
  PUT_PRODUCT_WITHOUT_REFRESH_SUCCESS: "PUT_PRODUCT_WITHOUT_REFRESH_SUCCESS",
  PUT_PRODUCT_WITHOUT_REFRESH_FAILURE: "PUT_PRODUCT_WITHOUT_REFRESH_FAILURE",

  CUSTOMER_ACTION_REQUEST: "CUSTOMER_ACTION_REQUEST",
  CUSTOMER_ACTION_SUCCESS: "CUSTOMER_ACTION_SUCCESS",
  CUSTOMER_ACTION_FAILURE: "CUSTOMER_ACTION_FAILURE",

  CHARGE_USPTO_FEE_REQUEST: "CHARGE_USPTO_FEE_REQUEST",
  CHARGE_USPTO_FEE_SUCCESS: "CHARGE_USPTO_FEE_SUCCESS",
  CHARGE_USPTO_FEE_FAILURE: "CHARGE_USPTO_FEE_FAILURE",

  FEE_RECHARGE_REQUEST: "POST_FEE_RECHARGE_REQUEST",
  FEE_RECHARGE_SUCCESS: "POST_FEE_RECHARGE_SUCCESS",
  FEE_RECHARGE_FAILURE: "POST_FEE_RECHARGE_FAILURE",

  GET_SUBSCRIPTIONS_DETAILS_REQUEST: "GET_SUBSCRIPTIONS_DETAILS_REQUEST",
  GET_SUBSCRIPTIONS_DETAILS_SUCCESS: "GET_SUBSCRIPTIONS_DETAILS_SUCCESS",
  GET_SUBSCRIPTIONS_DETAILS_FAILURE: "GET_SUBSCRIPTIONS_DETAILS_FAILURE",
};
